<template>
  <v-dialog v-model="dialog" max-width="600">
    <v-card>
      <v-card-title class="text-h6">
        {{ $t('message.infoloc.locomotive', { value: 'default' }) }} {{ cell.key }}
      </v-card-title>
      <v-card-text>
        <p><strong>{{ $t('message.magic.date', { value: 'default' }) }} :</strong> {{ cell.item.day }}</p>
        <p><strong>{{ $t('message.dispoc.recapLoc', { value: 'default' }) }} :</strong> {{ cell.item[cell.key]?.ind ||
          '—' }}</p>
        <v-alert dense text color="info" v-for="(memo, idx) in cell.item[cell.key]?.memos" :key="idx" class="px-2">
          <v-row>
            <v-col>
              <h5>{{ $t('message.magic.status', { value: 'default' }) }} </h5>
              <p><span>{{ memo }}</span></p>
            </v-col>

          </v-row>
        </v-alert>
        <v-progress-circular indeterminate color="primary" v-if="loader"></v-progress-circular>
        <div v-else>
          <v-alert dense text color="success" v-for="(wo, idx) in workorders" :key="idx" class="px-2">
            <v-row>
              <v-col>
                <h5>{{ wo.wonum }}</h5>
              </v-col>
              <v-col class="right-align"><span>{{ formatedDate(wo.startdate) }} - {{ formatedDate(wo.enddate)
                  }}</span></v-col>
            </v-row>
            <v-row>
              <v-col>
                <h5>{{ wo.wtypedesc }}</h5>
                <p><span>{{ wo.description }}</span></p>
              </v-col>

            </v-row>
          </v-alert>
        </div>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn text @click="$emit('update:dialog', false)">Fermer</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import MaximoService from "@/services/MaximoService";
import { formatMagicDate } from "@/shared/DateHelper"
export default {
  name: 'CellDetailDialog',
  props: {
    dialog: Boolean,
    cell: Object,
    assets: Array
  },
  data() {
    return {
      workorders: Array,
      loader: false
    }
  },
  computed: {
    title() {
      return this.cell.key === 'locDisp'
        ? 'Détail Disponibilité'
        : this.cell.key === 'locTot'
          ? 'Total Actif'
          : `Locomotive ${this.cell.key}`;
    },
  },
  methods: {

    formatedDate(date) {
      if (date == "") {
        return "";
      }

      if (date == undefined) {
        return "";
      }

      if (date == null) {
        return "";
      }
      return formatMagicDate(date, this.$i18n.locale);
    },
    loadDetails() {
      if (this.cell.item[this.cell.key].workorders !== undefined) {
        this.loader = true
        MaximoService.loadWoForAv({
          "srs": [],
          "workorders": this.cell.item[this.cell.key].workorders
        }).then(response => {
          this.workorders = response.data?.wks
          this.loader = false
        }).catch(() => {
          this.workorders = []
          this.loader = false
        })
      }

    },
    countNonCountable(item) {
      return Object.values(item)
        .filter(v => !v.countable)
        .length;
    }
  },
  watch: {
    dialog(value) {
      if (value) {
        this.loadDetails()
      }
    }
  }

};
</script>

<style scoped>
span {
  font-size: 0.8em;
  color: black;
}

.right-align {
  text-align: right;
}
</style>